import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { forkJoin } from 'rxjs';
import { PublicDataService } from 'src/app/core/services';
import { ConfirmService } from 'src/app/features/confirm';
import { Pattern } from 'src/app/utils/constants';
import { Confirm } from 'src/app/utils/models';
import { TarjetaPortada } from 'src/app/utils/models/usuario';
import { PromotionsService } from './promotions.service';

@Component({
  templateUrl: './promotions.component.html',
  styleUrls: ['./promotions.component.scss'],
})
export class PromotionsComponent {
  promotionsForm: FormGroup;
  instagramUrl: string = '';
  puedeVerInfo: boolean = true

  verTitulo: number = 0;
  titulo: string = '';
  verPregunta: number = 0;
  pregunta: string = '';
  respuestas: any = [];
  verRed: boolean = false;
  imgUrl: string = '';

  opcionesSeleccionadas: any = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public readonly tarjeta: TarjetaPortada,
    private readonly matDialogRef: MatDialogRef<never>,
    private readonly formBuilder: FormBuilder,
    private readonly publicData: PublicDataService,
    private translate: TranslateService,
    private toastr: ToastrService,
    private readonly confirm: ConfirmService,
    private promotionsService: PromotionsService,
  ) {
    this.promotionsForm = this.formBuilder.group({
      nombre: [null, [Validators.required, Validators.pattern(Pattern.NAME)]],
      telefono: [null, [Validators.required]],
      email: [null, [Validators.pattern(Pattern.EMAIL)]],
    });
    const redes = tarjeta.redesSociales.filter((red) =>
      red.urlRedSocial.includes('instagram')
    );
    if (redes.length) {
      this.instagramUrl = redes[0].urlRedSocial;
    }
    this.puedeVerInfo = promotionsService.puedeVerInfo
  }

  ngOnInit(): void {
    this.verTitulo = this.tarjeta.tituloHabilitado;
    this.titulo = this.tarjeta.tituloPopUp;   
    this.verPregunta = this.tarjeta.preguntaHabilitado;
    this.pregunta = this.tarjeta.pregunta;
    this.respuestas = this.tarjeta.respuestas;
    this.verRed = this.tarjeta.redHabilitado;

    let url = "https://tarjetasf.virtualplace.online"
    this.imgUrl = url.concat(this.tarjeta.imagenUrl);
    
    this.setColorCard();
  }

  submit(): void {
    if (this.promotionsForm.invalid) {
      this.promotionsForm.markAllAsTouched();
      return;
    }
    const body = {
      "IdCliente": 0,
      "IdTarjeta": this.tarjeta.idTarjeta,
      "Nombre": this.promotionsForm.get('nombre')?.value,
      "Email":this.promotionsForm.get('email')?.value,
      "Telefono":this.promotionsForm.get('telefono')?.value,
      "StrRespuestas":this.opcionesSeleccionadas.join(','),
      "IdUsuario":0,
      "Idioma":"esp"
    };
    this.publicData
      .addClient(body)
      .subscribe((response) => {
        if (response.msg === 'Cliente ya registrado') {
          forkJoin([
            this.translate.get('the_client_is_already_registered'),
          ]).subscribe((translate) => {
            this.toastr.error(translate[0].toUpperCase());
            this.matDialogRef.close();
          });

          return;
        }

        if (!localStorage.getItem('promo_status')) {
          localStorage.setItem('promo_status', JSON.stringify(true));
        }

        forkJoin([this.translate.get('thank_you_for_registering')]).subscribe(
          (translate) => {
            this.toastr.success(translate[0].toUpperCase());
            this.matDialogRef.close();
          }
        );
      });
  }

  private setColorCard(): void {
    const colorTarjeta = this.tarjeta.colorTarjeta;
    const colorLetra = this.tarjeta.colorLetra;
    
    document.documentElement.style.setProperty('--page_back', colorTarjeta);
    document.documentElement.style.setProperty('--page_color', colorLetra);
  }

  // dejarDeMostrar() {
  //   const confirm = new Confirm();
  //   confirm.title = 'Dejar de mostrar';
  //   this.confirm
  //     .open(confirm)
  //     .afterClosed()
  //     .subscribe((response) => {
  //       if (response) {
  //         if (!localStorage.getItem('promo_status')) {
  //           localStorage.setItem('promo_status', JSON.stringify(true));
  //         }
  //         this.matDialogRef.close();
  //       }
  //       this.matDialogRef.close();
  //     });
  // }

  guardarRespuestas(opcion: string) {
    this.opcionesSeleccionadas.push(opcion);
  }
}
